
export { useEventsPerPartner } from "/home/runner/work/capsicum/capsicum/libs/features/nc-wallet/shared/src/hooks/useEventsPerPartner.tsx"